import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { MmsAdminActions } from './mms-admin-override.actions';
import { MmsAdminSelectors } from './mms-admin-override.selectors';
import { ManagementBaseActions } from '../base/management-base.actions';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {SearchFilter} from '@emm/core/models/search-filter';


export interface MMSAdminOverrideQueries extends AsyncActionQueries {
    all$: Observable<any[]>;
    locations$: Observable<any[]>;
    selected$: Observable<any>;
    selections$: Observable<any>;
    templateOptionsByLocation$: Observable<any>;
    templateByLocation$: Observable<any>;
}

@Injectable({
    providedIn: 'root',
})
export class MmsAdminOverrideStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, MmsAdminSelectors);
    }

    dispatch = {
        selectLocation: (selected: any) => this.store.dispatch(MmsAdminActions.select({ selected })),
        savedSelections: (selections: any, storeNumber: any, selectedEffectiveDate: any) =>
            this.store.dispatch(MmsAdminActions.savedSelections({ selections, storeNumber, selectedEffectiveDate })),
        searchLocation: (filter: SearchFilter) =>
            this.store.dispatch(ManagementBaseActions.searchLocation({ filter })),
    };

    queries: MMSAdminOverrideQueries = {
        all$: this.selectNonNil(MmsAdminSelectors.getFilteredItems),
        selected$: this.selectNonNil(MmsAdminSelectors.getSelected),
        selections$: this.selectNonNil(MmsAdminSelectors.getSavedSelections),
        locations$: this.selectNonNil(MmsAdminSelectors.getLocations),
        templateOptionsByLocation$: this.selectNonNil(MmsAdminSelectors.getTemplateOptionsByLocation),
        templateByLocation$: this.selectNonNil(MmsAdminSelectors.getTemplateByLocation),
        ...this.asyncActionQueries,
    };
}
